import React from 'react'

export interface IEditorProvider {
  editorContext: Record<string, any>
}

export const EditorProvider = React.createContext<IEditorProvider | null>(null);